import { DatePipe } from '@angular/common';
import { Component, Injector, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ROLE_AGENTE_CONSULTA, ROLE_GESTOR_CONSULTA } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { AtualizacaoInformacoesRiscoOperacao } from 'src/app/model/atualizacao-info-risco.model';
import { STATUS_PROTOCOLO } from 'src/app/model/protocolo-arquivo.model';
import { OcorrenciaValidacaoVO } from 'src/app/shared/ocorrencia-validacao.vo';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { AtualizacaoInfoRiscoService } from './atualizacao-info-risco.service';

@Component({
    templateUrl: './atualizacao-info-risco-detalhe.component.html',
    styleUrls: ['./atualizacao-info-risco-detalhe.component.scss'],
    standalone: false
})
export class AtualizacaoInfoRiscoDetalheComponent implements OnInit {

    private agentesFinanceiros: AgenteFinanceiro[] = [];
    public idAtualizacao:number = null;
    private ocorrencias: OcorrenciaValidacaoVO[] = [];
    public atualizacaoForm: UntypedFormGroup = null;
    public podeVisualizarValidacoes: boolean;
    
    constructor(protected injector: Injector,
        private service: AtualizacaoInfoRiscoService,
        private permissaoService: PermissaoService,
        private activatedRoute: ActivatedRoute,
        private datePipe: DatePipe,
        private fb: UntypedFormBuilder,
        private router:Router
    ) {
        this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
        // this.config.rotaLista = '/solicitacoes-honra/pesquisa';
    }

    criarFormulario() {
        return this.fb.group({
            cnpjAgenteFinanceiro: null,
            idOperacao: null,
            sistemaCobranca: null,
            idExternoOperacao: null,
            contrato: null,
            dataEnvio: null,
            statusProtocolo: null,
            liquidada: null,
            riscoOperacao:null,
            tipoProtocolo:null
        });
    }

    ngOnInit() {
        this.permissaoService.getPermissoesUsuarioAutenticado().subscribe(resp =>{
            if(resp[ROLE_AGENTE_CONSULTA] || resp[ROLE_GESTOR_CONSULTA]){
                this.activatedRoute.params
                .pipe(
                    switchMap((params)=>{
                        const id = params['id'];
                        if(id){
                            return this.service.findById(id);
                        }
                        
                        return of(new AtualizacaoInformacoesRiscoOperacao())
                    })
                )
                .subscribe( model =>{
                    this.idAtualizacao = model.id;
                    this.construirFormulario(model);
                    this.atualizacaoForm.disable();
                });
            }
            else {
                this.voltar();
            }
        })
    }

    voltar() {
        this.router.navigate(['/atualizacao-info-risco/pesquisa']);
    }

    construirFormulario(model: AtualizacaoInformacoesRiscoOperacao) {
        if (!this.atualizacaoForm) {
            this.atualizacaoForm = this.criarFormulario();
        }
        if(model){
            this.atualizacaoForm.patchValue({
                cnpjAgenteFinanceiro: model?.cnpjAgenteFinanceiro || null,
                idOperacao: model?.idOperacao || null,
                sistemaCobranca: model?.sistemaCobranca || null,
                idExternoOperacao: model?.idOperacaoAgente || null,
                contrato: model?.contratoCobranca || null,
                dataEnvio: model?.dataEnvio ? this.datePipe.transform(model.dataEnvio, "dd/MM/yyyy") : null,
                statusProtocolo: model?.statusProtocolo ? STATUS_PROTOCOLO.filter(s => model.statusProtocolo == s.codigo)[0]?.label :null,
                liquidada: model?.liquidada==='S' ? true : false || null,
                riscoOperacao: model?.riscoOperacao || null,
                tipoProtocolo: model?.tipoProtocolo || null
            });
        }
    }

}